define [], () ->
  helper = (num) ->
    num ? window.format_full_number num : ''

  helper



// WEBPACK FOOTER //
// ./app/scripts/Hasadna/oBudget/Misc/handlebarsHelpers/format_full_number.coffee